export default __webpack_public_path__ + "static/media/Capture-removebg-preview.cfe7dc0e.png";